module.exports = __webpack_public_path__ + "static/media/Pattern_3.a18d8c2f.png";